<div class="search-config m-t-20">
  <p class="section-title title d-flex m-0">
    <span class="material-symbols-outlined d-flex m-r-4"> manufacturing </span>

    {{ 'paymentHistory.searchConfiguration' | cxTranslate }}
  </p>

  <form class="m-t-20" [formGroup]="form" (submit)="submit()">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <div class="col-12"></div>
          <label for="" class="label-container">
            <span class="label-content">{{ 'paymentHistory.searchBy' | cxTranslate }}</span>

            <div class="form-check" *ngFor="let type of attributesType">
              <input
                id="attributeType-{{ type.code }}"
                class="form-check-input"
                role="radio"
                type="radio"
                aria-checked="true"
                [value]="type.code"
                formControlName="attributeType"
              />

              <label class="cx-payment-type-label form-check-label form-radio-label" for="attributeType-{{ type.code }}">
                <div class="cx-payment-type">
                  {{ type.label }}
                </div>
              </label>
            </div>
          </label>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="" class="label-container">
            <span class="label-content">{{ 'paymentHistory.searchType' | cxTranslate }}</span>

            <div class="form-check" *ngFor="let type of searchType">
              <input
                id="searchType-{{ type.code }}"
                class="form-check-input"
                role="radio"
                type="radio"
                aria-checked="true"
                [value]="type.code"
                formControlName="searchType"
              />

              <label class="cx-payment-type-label form-check-label form-radio-label" for="searchType-{{ type.code }}">
                <div class="cx-payment-type">
                  {{ type.label }}
                </div>
              </label>
            </div>
          </label>
        </div>
      </div>

      <div class="col-12 col-md-9">
        <div class="form-group">
          <label>
            <input class="form-control" type="text" name="value" maxlength="10" [placeholder]="placeholder" formControlName="value" />

            <cx-form-errors [control]="form.get('value')"></cx-form-errors>
          </label>
        </div>
      </div>

      <div class="col-12 col-md-3">
        <div class="form-group">
          <button class="btn btn-primary btn-sm w-100">
            <span class="material-symbols-outlined d-flex m-r-4"> search </span>

            {{ 'paymentHistory.search' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <ng-container
    *ngIf="{
      report: report$ | async,
    } as content"
  >
    @if (!content.report?.isPristine) {
      @if (!content.report?.isLoading) {
        <div class="m-t-8">
          <p class="section-title title d-flex v-center m-0">
            <span class="material-symbols-outlined d-flex m-r-4"> query_stats </span>

            {{ 'paymentHistory.myRecentPayment' | cxTranslate }}
          </p>
        </div>

        @if (!content.report?.hasError) {
          @if (content.report?.table?.length) {
            <table-pro [configs]="tableConfig">
              <table class="table-responsive table-md">
                <thead>
                  <tr>
                    <th>{{ 'paymentHistory.yourPayment' | cxTranslate }}</th>
                    <th>{{ 'paymentHistory.receiptDate' | cxTranslate }}</th>
                    <th>{{ 'paymentHistory.paymentAmount' | cxTranslate }}</th>
                    <th>{{ 'paymentHistory.appliedAmount' | cxTranslate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of content.report?.table">
                    <td [attr.data-value]="item?.yourPayment">
                      <span class="responsive-title"> {{ 'paymentHistory.yourPayment' | cxTranslate }}: </span>

                      <button type="button" class="btn-action" (click)="openPaymentHistoryDetails(item)">
                        {{ item.yourPayment }}
                      </button>
                    </td>

                    <td [attr.data-value]="item?.receiptDate">
                      <span class="responsive-title"> {{ 'paymentHistory.receiptDate' | cxTranslate }}: </span>

                      {{ item?.receiptDate | cxDate: 'MM/dd/yyyy' }}
                    </td>

                    <td [attr.data-value]="item?.paymentAmount?.value">
                      <span class="responsive-title"> {{ 'paymentHistory.paymentAmount' | cxTranslate }}: </span>

                      {{ item?.paymentAmount?.formattedValue }}
                    </td>

                    <td [attr.data-value]="item?.appliedAmount?.value">
                      <span class="responsive-title"> {{ 'paymentHistory.appliedAmount' | cxTranslate }}: </span>

                      {{ item?.appliedAmount?.formattedValue }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </table-pro>
          } @else {
            <p class="ff-bold text-center m-t-20">{{ 'paymentHistory.noPaymentsFound' | cxTranslate }}</p>
          }
        } @else {
          <alert [alert]="alertDanger"></alert>
        }
      } @else {
        <div class="m-t-20">
          <local-loader></local-loader>
        </div>
      }
    }
  </ng-container>
</div>